// The field-goal upright, drawn as an official diagram.
//
// DESIGN.md calls this "the single most memorable element on the site" and it
// lived only on the landing page — the product's empty states used a generic
// trophy, which is the one icon every fantasy app already has. This is the
// brand's own mark, so the empty screens read as ours.
//
// Square caps and a flat gold stroke: a printed diagram, not an illustration.
// Decorative — every instance is aria-hidden and the surrounding copy carries
// the meaning.
import React from 'react';

interface GoalpostProps {
  /** Rendered width; the shape keeps its aspect ratio. */
  className?: string;
}

export const Goalpost: React.FC<GoalpostProps> = ({ className = 'w-16 h-16' }) => (
  <svg
    viewBox="0 0 100 86"
    className={className}
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    {/* base post */}
    <path d="M50 86 V46" stroke="currentColor" strokeWidth="9" strokeLinecap="square" />
    {/* crossbar */}
    <path d="M18 46 H82" stroke="currentColor" strokeWidth="9" strokeLinecap="square" />
    {/* uprights */}
    <path d="M18 46 V6" stroke="currentColor" strokeWidth="9" strokeLinecap="square" />
    <path d="M82 46 V6" stroke="currentColor" strokeWidth="9" strokeLinecap="square" />
  </svg>
);

export default Goalpost;
